(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-expanded.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-expanded.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (Backbone, _, svs) {
  svs.tipset.views.BetslipExpanded = Backbone.Marionette.View.extend({
    template: function template(data) {
      return svs.tipset.templates.betslipexpanded(data);
    },
    templateContext: function templateContext() {
      return {
        isReduceMode: svs.tipset.models.play.get('isReduceMode')
      };
    },
    regions: {
      matchlist: '#betslipMatchlist',
      systeminfo: '#betslipSysteminfo',
      sportkryss: '#sportkryssRegion',
      betAmountPicker: '#betAmountPickerRegion',
      bomben: '#bombenRegion',
      weekpicker: '#weeekPickerRegion',
      betslipErrorMessage: '#betslipErrorMessage'
    },
    modelEvents: {
      'change:showBombenBetslipInfo': 'handleBombenInfo',
      updateAccount: 'onAccountChangeBetslipExpanded'
    },
    className: 'betslip-expanded',
    events: {
      'click .js-remove-bomben-bet': 'removeBombenBet'
    },
    ui: {
      selectedRows: '.js-selected-rows',
      possibleRows: '.js-possible-rows'
    },
    log: new svs.core.log.Logger('svs.tipset.views.BetslipExpanded'),
    initialize: function initialize() {
      var self = this;
      this.uid = svs.tipset.getUid();
      this.handleReduceMode();
      this.listenTo(svs.tipset.models.play, 'change', function () {
        self.handleReduceMode();
        self.render();
      });
      this.listenTo(svs.tipset.models.reduceFreeContainer, 'change:rows', this.handleReduceMode.bind(this)); 

      if (svs.tipset.models.play.get('isReduceMode')) {
        this.listenTo(svs.tipset.collections.matchlist, 'buttonBet', function () {
          self.handleReduceMode();
          self.render();
        });
        this.listenTo(svs.tipset.collections.matchlist, 'updateWeights', function () {
          self.handleReduceMode();
          self.render();
        });
      }
    },
    onAccountChangeBetslipExpanded: function onAccountChangeBetslipExpanded() {
      var hasMarketPlaceAccount = svs.components.marketplace && svs.components.marketplace.accountSelector,
          isMarketPlaceAccount = hasMarketPlaceAccount && svs.components.marketplace.accountSelector.helpers.getCurrentAccount();

      if (isMarketPlaceAccount) {
        if (!svs.tipset.models.play.get('isReduceMode')) {
          if (!svs.tipset.models.gameDefinitions.hasWeekPicker() && svs.tipset.models.weekPicker) {
            svs.tipset.models.weekPicker.setNumDraws(1);
            this.getRegion('weekpicker').empty();

            if (!svs.core.detect.feature('ft-betslip')) {
              svs.tipset.views.betslip.doResize();
            }
          }

          if (!svs.core.detect.feature('ft-marketplace-sportkryss') && svs.tipset.models.gameDefinitions.get('hasSportkryss') && svs.components.marketplace) {
            this.getRegion('sportkryss').empty();

            if (!svs.core.detect.feature('ft-betslip')) {
              svs.tipset.views.betslip.doResize();
            }
          } else {
            if (svs.tipset.models.gameDefinitions.get('hasSportkryss') && !svs.tipset.models.play.get('isReduceMode') && !this.getRegion('sportkryss').hasView()) {
              this.getRegion('sportkryss').show(new svs.tipset.views.Sportkryss({
                model: svs.tipset.models.sportkryss
              }));

              if (!svs.core.detect.feature('ft-betslip')) {
                svs.tipset.views.betslip.doResize();
              }
            }
          }
        }
      } else {
        if (svs.tipset.models.gameDefinitions.hasWeekPicker() && !svs.tipset.models.play.get('isReduceMode')) {
          this.getRegion('weekpicker').show(new svs.tipset.views.WeekPicker({
            model: svs.tipset.models.weekPicker
          }));
          this.getRegion('sportkryss').show(new svs.tipset.views.Sportkryss({
            model: svs.tipset.models.sportkryss
          }));

          if (!svs.core.detect.feature('ft-betslip')) {
            svs.tipset.views.betslip.doResize();
          }
        }
      }
    },
    onDestroy: function onDestroy() {
      if (svs.components.marketplace && svs.components.marketplace.accountSelector) {
        svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.onAccountChangeBetslipExpanded);
      }
    },
    onDomRefresh: function onDomRefresh() {
      this.handleReduceMode();
    },
    handleReduceMode: function handleReduceMode() {
      if (svs.tipset.models.play.get('isReduceMode')) {
        this.$el.addClass('is-reduce-mode');

        if (_typeof(this.ui.selectedRows) === 'object' && _typeof(this.ui.possibleRows) === 'object') {
          this.ui.selectedRows.text(svs.tipset.models.reduceFreeContainer.get('rows'));
          this.ui.possibleRows.text(svs.tipset.collections.matchlist.getNrOfRows());
        }
      } else {
        this.$el.removeClass('is-reduce-mode');
      }

      if (!svs.core.detect.feature('ft-betslip')) {
        svs.tipset.views.betslip.doResize();
      }
    },
    onRender: function onRender() {
      var self = this;
      var betslipMatchList, systemInfo;

      if (svs.tipset.models.play.get('isSingleRow')) {
        betslipMatchList = new svs.tipset.views.BetslipSingleboardsCoupon({
          model: svs.tipset.models.betslipFooter
        });
      } else {
        betslipMatchList = new svs.tipset.views.BetslipMatchlist({
          collection: new svs.tipset.collections.BetslipMatchlist()
        });
        systemInfo = new svs.tipset.views.BetslipSysteminfo({
          model: new svs.tipset.models.BetslipSysteminfo()
        });
      }

      this.getRegion('matchlist').show(betslipMatchList);

      if (systemInfo && !svs.tipset.models.play.get('isReduceMode')) {
        this.getRegion('systeminfo').show(systemInfo);
      }

      this.handleBombenInfo();

      if (svs.tipset.models.gameDefinitions.hasWeekPicker() && !svs.tipset.models.play.get('isReduceMode')) {
        this.getRegion('weekpicker').show(new svs.tipset.views.WeekPicker({
          model: svs.tipset.models.weekPicker
        }));
      }

      if (svs.tipset.models.gameDefinitions.hasSportkryss() && !svs.tipset.models.play.get('isReduceMode')) {
        this.getRegion('sportkryss').show(new svs.tipset.views.Sportkryss({
          model: svs.tipset.models.sportkryss
        }));
      }

      this.getRegion('betslipErrorMessage').show(new svs.tipset.views.BetslipErrorMessage({
        model: new svs.tipset.models.BetslipErrorMessage()
      }));

      if (svs.tipset.models.gameDefinitions.get('rowPrices').length > 1) {
        new svs.sport.BetAmountPicker($('#betAmountPickerRegion', this.$el), {
          betAmounts: this.model.get('rowPrices'),
          currentBetAmount: this.model.get('amount'),
          isValid: true,
          showCustomBetAmount: false,
          buttonCSSClass: "btn-toggle-betslip-".concat(svs.tipset.models.gameDefinitions.get('htmlClass')),
          informationText: 'Insats per rad:',
          onBetAmountChanged: function onBetAmountChanged(amount) {
            self.model.onBetAmountChanged(amount);
            self.log.debug("onBetAmountChanged wager model updated rowPrice to ".concat(self.model.get('amount')));
          },
          onValidationChanged: function onValidationChanged(valid, amount) {
            self.model.onBetAmountChanged(amount);
            self.log.debug("onValidationChanged wager model updated rowPrice to ".concat(self.model.get('amount')));
          }
        });
      }

      svs.tipset.calls.addCall("betslip-expanded ".concat(this.uid));
      setTimeout(function () {
        if (window.location.href.indexOf('tipssm') > -1 && $('#betslip-header').text().indexOf('Tips-SM') < 1) {
          $('#betslip-header').prepend('<div style="float: left; text-align: left;" class="f-400 f-bold">Du spelar Tips-SM</div>').css({
            'padding-top': '10px',
            'padding-bottom': '10px'
          });
        }
      }, 100);
    },
    onBetAmountChanged: function onBetAmountChanged(newAmount) {
      this.set('amount', newAmount);
    },
    handleBombenInfo: function handleBombenInfo() {
      if (this.model.get('showBombenBetslipInfo')) {
        this.getRegion('bomben').show(new svs.tipset.views.BetslipBomben({
          model: svs.tipset.models.bombenXperten
        }));
      } else {
        this.getRegion('bomben').empty();
      }

      if (!svs.core.detect.feature('ft-betslip')) {
        svs.tipset.views.betslip.doResize();
      }
    }
  });
})(Backbone, _, svs);
 })(window);